// extracted by mini-css-extract-plugin
export default {"wrapper":"vp_SVBvT","legend":"vp_gWBe3","legendItemAdded":"vp_zinXI","legendItemRemoved":"vp_ku8ct"};